export default __webpack_public_path__ + "60c11fc5a5f49bc6e81a6cf67852a217.png";